import styled from 'styled-components'
import { Layout } from 'antd'
import Color from './constants/color.constants'
export const MarginDisplay = styled.div`
  // background-color: #000 !important;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  width: 100%;
  flex: 1;
`

export const ContainerHeader = styled.div`
  width: 100%;
  // height: 1400px;
  min-height: 100vh;
  // background-color: #000;
  // margin-left: 100px;
  // padding: 10px;
  .trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color 0.3s;
  }

  .trigger:hover {
    color: ${Color.orange};
  }

  .logo {
    height: 32px;
    background: rgba(255, 255, 255, 0.3);
    margin: 16px;
  }

  .header {
    background: ${Color.white};
  }
  .ant-layout-sider {
    background: linear-gradient(180deg, ${Color.blue} 53.12%, #015093 98.96%);
    .ant-menu.ant-menu-dark {
      background: transparent;
    }
  }
  .ant-layout-sider-mobile {
    position: relative;
    min-width: 0;
    background: ${Color.primary};
    -webkit-transition: all 0.2s;
    transition: all 0.2s;
  }

  .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background-color: ${Color.blue};
  }
`

// export const Container = styled.div`
//   display: block;
//   flex-direction: column;
//   min-height: 83vh;
// `

export const LayoutContainer = styled(Layout)`
  width: 100%;
  min-height: 100vh;
  // background-color: #000 !important;
  -webkit-transition: 0.3s ease all;
  transition: 0.3s ease all;
  .ant-layout-content {
    margin: 28px;
    display: flex;
    flex-direction: column;
  }

  .ant-form-item-label {
    > label {
      color: ${Color.formLabel};
      font-weight: 300;
      font-size: 14px;
      line-height: 21px;
    }
  }

  .ant-layout-footer {
    padding: 40px 50px 0;
    font-size: 16px;
    line-height: 24px;
    color: ${Color.textBlack};
  }

  .ant-tag {
    font-size: 10px;
    border: 0;
    text-align: center;
    border-radius: 5px;
  }

  .ant-tag-green {
    background: rgba(48, 201, 72, 0.2);
    color: #217a2f;
  }

  .ant-btn {
    transition-duration: 200ms;
    &[disabled] {
      opacity: 0.5;
    }
  }

  .ant-btn-primary {
    color: ${Color.white};
    border-color: ${Color.blue};
    background: ${Color.blue};
    &:hover {
      border-color: ${Color.hoverBlue};
      background: ${Color.hoverBlue};
    }
  }

  .ant-btn-secondary {
    color: ${Color.blue};
    border-color: ${Color.blue};
    background: ${Color.white};
    &:hover {
      color: ${Color.hoverBlue};
      border-color: ${Color.hoverBlue};
    }
  }

  .ant-dropdown-menu {
    box-shadow: 0px 4px 16px rgb(0 0 0 / 16%);
    border-radius: 8px;
    overflow: hidden;
    padding: 8px 0;
    .ant-dropdown-menu-item,
    .ant-dropdown-menu-submenu-title {
      font-size: 14px;
      line-height: 18px;
      &:hover {
        background: ${Color.dropdown};
      }
    }
  }
`
export const TitlePrimary = styled.div`
  font-family: IBMPlexSansThaiBold;
  color: #127ec3;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 31px;
  text-align: center;
  padding-bottom: 24px;
`
